/* unplugin-vue-components disabled */import script from "./editLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./editLayout.vue?vue&type=script&setup=true&lang=ts"

import "./editLayout.vue?vue&type=style&index=0&id=605666af&lang=scss"

const __exports__ = script;

export default __exports__